// Styled Modal с повышенным z-index
import styled, {createGlobalStyle, keyframes} from "styled-components";
import {Modal} from "@consta/uikit/Modal";
import {Button} from "@consta/uikit/Button";

export const StyledModal = styled(Modal)`
    z-index: 2147483000 !important;
    isolation: isolate;

    .Modal-Overlay {
        z-index: 2147482998 !important;
        background: rgba(6, 35, 52, 0.78) !important;
    }

    .Modal-Window {
        z-index: 2147482999 !important;
        background: #f5f7fa !important;
        overflow: hidden;
        isolation: isolate;
        transform: translateZ(0);
        backface-visibility: hidden;
    }

    .Modal-Content {
        background: #f5f7fa !important;
        overflow: auto !important;
        isolation: isolate;
        transform: translateZ(0);
    }
`;

export const BsiPayloadModalGlobalShield = createGlobalStyle`
    body.bsi-payload-modal-open .ag-theme-alpine .ag-header-cell-resize,
    body.bsi-payload-modal-open .ag-theme-alpine .ag-header-cell-resize::after,
    body.bsi-payload-modal-open .ag-theme-alpine .ag-header-cell::after,
    body.bsi-payload-modal-open .ag-theme-alpine .ag-header-group-cell::after {
        opacity: 0 !important;
        visibility: hidden !important;
    }

    body.bsi-payload-modal-open .ag-theme-alpine .ag-cell,
    body.bsi-payload-modal-open .ag-theme-alpine .ag-header-cell,
    body.bsi-payload-modal-open .ag-theme-alpine .ag-header-group-cell {
        border-right-color: transparent !important;
    }
`;


// Styled Components
export const ModalContainer = styled.div`
    padding: 24px;
    background: #f5f7fa;
    border-radius: 12px;
    min-height: 400px;
    position: relative;
    z-index: 1;
    isolation: isolate;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        z-index: -1;
        border-radius: inherit;
        background: #f5f7fa;
    }
`;

export const ModalHeader = styled.div`
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #e2e8f0;
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #1a202c;
    display: flex;
    align-items: center;
    gap: 12px;

    &:before {
        content: '📁';
        font-size: 28px;
    }
`;

export const ModalSubtitle = styled.p`
    margin: 8px 0 0 0;
    font-size: 14px;
    color: #718096;
`;

export const FileCard = styled.div`
    background: white;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    border: 1px solid #e2e8f0;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
    }
`;

export const ProgressBarContainer = styled.div`
    margin: 24px 0;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const ProgressBarWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 8px;
    background: #e2e8f0;
    border-radius: 4px;
    overflow: hidden;
`;

export const shimmer = keyframes`
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;

export const ProgressBarFill = styled.div<{ progress: number }>`
    height: 100%;
    width: ${props => props.progress}%;
    background: linear-gradient(90deg, #4299e1 0%, #3182ce 50%, #2c5282 100%);
    background-size: 200% 100%;
    animation: ${shimmer} 2s infinite;
    border-radius: 4px;
    transition: width 0.3s ease;
`;

export const ProgressText = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
`;

export const ProgressLabel = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;

    &:before {
        content: '⚙️';
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export const FileStatus = styled.div<{ status: 'pending' | 'processing' | 'success' | 'error' }>`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    min-height: 30px;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;

    ${props => {
        switch (props.status) {
            case 'pending':
                return `
                    background: #edf2f7;
                    color: #4a5568;
                `;
            case 'processing':
                return `
                    background: #bee3f8;
                    color: #2c5282;
                `;
            case 'success':
                return `
                    background: #c6f6d5;
                    color: #22543d;
                `;
            case 'error':
                return `
                    background: #fed7d7;
                    color: #742a2a;
                `;
        }
    }}
`;

export const FileActionsRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
`;

export const SmallActionButton = styled.button`
    border: 1px solid #b8c8d9;
    border-radius: 8px;
    background: #ffffff;
    color: #0b4f79;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    min-height: 30px;
    padding: 7px 10px;

    &:hover:not(:disabled) {
        background: #eef7ff;
        border-color: #7aa7c9;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.55;
    }
`;

export const BulkPanel = styled.div`
    margin-bottom: 18px;
    padding: 14px;
    border: 1px solid #d8e2ee;
    border-radius: 8px;
    background: #ffffff;
`;

export const BulkTitle = styled.div`
    margin-bottom: 10px;
    font-size: 13px;
    font-weight: 700;
    color: #1a365d;
`;

export const BulkFields = styled.div`
    display: grid;
    grid-template-columns: minmax(220px, 1.1fr) minmax(220px, 1fr) minmax(100px, 0.45fr) auto auto;
    gap: 10px;
    align-items: center;

    @media (max-width: 1200px) {
        grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const TripsPreview = styled.div`
    margin-top: 14px;
    padding: 12px;
    border: 1px solid #d8e2ee;
    border-radius: 8px;
    background: #f8fbff;
`;

export const TripsTitle = styled.div`
    margin-bottom: 8px;
    font-size: 13px;
    font-weight: 700;
    color: #1a365d;
`;

export const TripRow = styled.div`
    display: grid;
    grid-template-columns: minmax(190px, 0.8fr) minmax(260px, 1.5fr) minmax(150px, 0.9fr) minmax(90px, 0.45fr);
    gap: 8px;
    align-items: center;
    padding: 8px 0;
    border-top: 1px solid #e2e8f0;

    &:first-of-type {
        border-top: 0;
    }

    @media (max-width: 1100px) {
        grid-template-columns: 1fr;
    }
`;

export const TripMeta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    color: #2d3748;

    strong {
        font-size: 13px;
        color: #1a202c;
    }

    span {
        font-size: 12px;
        color: #718096;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e2e8f0;
`;

export const OperationPanel = styled.div`
    margin-top: 16px;
    padding: 14px;
    border: 1px solid #d8e2ee;
    border-radius: 8px;
    background: #ffffff;
`;

export const OperationHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 10px;
`;

export const OperationTitle = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: #1a202c;
`;

export const OperationSubtitle = styled.div`
    margin-top: 2px;
    font-size: 12px;
    color: #718096;
`;

export const OperationPercent = styled.div`
    min-width: 44px;
    text-align: right;
    font-size: 16px;
    font-weight: 700;
    color: #1a365d;
`;

export const OperationProgressTrack = styled.div`
    height: 7px;
    overflow: hidden;
    border-radius: 999px;
    background: #e2e8f0;
`;

export const OperationProgressFill = styled.div<{ progress: number }>`
    width: ${props => Math.max(0, Math.min(100, props.progress))}%;
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, #3182ce 0%, #38a169 100%);
    transition: width 0.25s ease;
`;

export const OperationLog = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 220px;
    margin-top: 12px;
    overflow: auto;
    padding-right: 4px;
`;

export const OperationLogItem = styled.div<{ status: 'info' | 'success' | 'error' | 'warning' }>`
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 9px 10px;
    border-left: 4px solid;
    border-radius: 6px;
    background: #f8fbff;
    border-left-color: ${props => {
        switch (props.status) {
            case 'success':
                return '#38a169';
            case 'error':
                return '#e53e3e';
            case 'warning':
                return '#d69e2e';
            default:
                return '#3182ce';
        }
    }};

    strong {
        font-size: 13px;
        color: #1a202c;
    }

    span {
        font-size: 12px;
        color: #4a5568;
        line-height: 1.35;
        white-space: pre-wrap;
    }
`;

export const StyledButton = styled(Button)`
    &.cancel {
        margin-left: 8px;
    }
`;
